import { useEffect } from 'preact/hooks';
import { useRouterState } from '@tanstack/react-router';

// The apex (movegoalpost.com) and www serve the same marketing site, so without
// a canonical the two hosts get indexed as duplicate pages. Force the www origin
// on every route; path only, so campaign UTM params collapse onto the clean URL.
// Client-rendered stopgap until prerendering can do a real apex→www redirect.
const CANONICAL_ORIGIN = 'https://www.movegoalpost.com';

export function useCanonicalUrl() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = `${CANONICAL_ORIGIN}${pathname}`;
  }, [pathname]);
}
